<template>
    <div :class="{'d-flex flex-grow-1': coreParams.all_private_albums && +coreParams.all_private_albums}">
        <div id="content" :class="{'d-flex flex-column justify-content-center -has-bg  -show-bg': coreParams.all_private_albums && +coreParams.all_private_albums}">
            <div v-if="coreParams.all_private_albums && +coreParams.all_private_albums" class="container">
                <div class="hidden-album-box">
                    <div class="hidden-album-box-title">{{ $t('private_gallery') }}</div>
                    <div class="row">
                        <div class="col-md-7">
                            <div class="hidden-album-box-text">{{ $t('descriptions.personal_albums') }}</div>
                            <div v-if="coreParams.shop_design && coreParams.shop_design.info_text" class="hidden-album-box-text">
                                <hr><div v-html="coreParams.shop_design.info_text"></div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <hidden-album-form :label="!isMobile" position="top"/>
                        </div>
                    </div>
                </div>
            </div>
            <template v-else>
                <breadcrumbs :show-password-field="true" offset-top="0"/>
                <div class="container">
                    <gallery/>
                </div>
            </template>
        </div>
        <powered-by v-if="hasPoweredBy"/>
        <vue-headful :title="headTitle($t('gallery'))"/>
    </div>
</template>

<script>
  import HiddenAlbumForm from '../components/HiddenAlbumForm.vue';
  import Gallery from '../components/Gallery.vue';
  import PoweredBy from '../components/PoweredBy.vue';
  import Breadcrumbs from '../components/Breadcrumbs.vue';

  export default {
    components: {
      HiddenAlbumForm,
      Gallery,
      PoweredBy,
      Breadcrumbs,
    },
  };
</script>

<style lang="scss" scoped>
    @import "../scss/variables";

    .-has-bg {
        position: relative;
        overflow: hidden;

        &::before {
            position: absolute;
            content: '';
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: var(--page-bg-color) var(--page-bg-image) 50% 50% no-repeat;
            background-size: cover;
            z-index: 0;
        }

        > * {
            position: relative;
            z-index: 1;
        }
    }

    .-show-bg::before {
        opacity: 1;
    }

    .-blur::before {
        filter: blur($blur);
    }
</style>